import {formatoFechaExportacion} from "../../Utilidades/formatoFechaExportacion";
import {formatoFechaTabla} from "../../Modulo_Tabla_2025/Utilidades/formatoFechaTabla";

export const adaptador_movimientos_caja = (movs) => {


    let arr = []
    for (let i = 0; i < movs.length; i++) {
        let movimiento = movs[i]
        let obj = {
            Fecha: formatoFechaTabla(movimiento.fecha),
            Tipo: movimiento.tipo,
            Origen: movimiento.origen ?  movimiento.origen : '',
            Valor: movimiento.valor,
            Descripcion: movimiento.descripcion ?  movimiento.descripcion : '',
        }
        arr.push(obj)
    }

    return arr

}